document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) return;

  const interval = setInterval(() => {
    const gallery = document.querySelector('.product-media, .product-gallery');

    if (!gallery || !gallery.classList.contains('flickity-enabled')) return;

    const flkty = Flickity.data(gallery);
    if (!flkty) return;

    // Active les dots Flickity
    flkty.options.pageDots = true;
    flkty.resize();

    clearInterval(interval);
    console.log('✅ Flickity dots activés');
  }, 300);
});
document.addEventListener("scroll", function () {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  if (window.scrollY > 50) {
    bar.classList.add('hide-bar');
  } else {
    bar.classList.remove('hide-bar');
  }
});